import React from 'react';
import PropTypes from 'prop-types';

import CreditCardForm from './methods/creditCard/CreditCardForm';
import PointsForm from './methods/points/PointsForm';
import SamsungPayForm from "./methods/samsungPay/SamsungPayForm";
import { PaymentRequestProvider } from './PaymentRequestProvider';

import {SAMSUNG_PAY, POINTS, STORED_PAYMENT} from './paymentMethodTypes';
import { usePaymentMethods } from './PaymentMethodProvider';
import {StoredPaymentTabs} from './methods/storedPayments/StoredPaymentFields'
const PaymentMethod = (props) => {
    const { selectedMethod, onMethodError } = usePaymentMethods();
    const methodProps = {onMethodError, ...props};
    switch (selectedMethod) {
        case POINTS: {
            return <PointsForm {...methodProps} />;
        }
        case SAMSUNG_PAY: {
            return <PaymentRequestProvider><SamsungPayForm {...methodProps} /></PaymentRequestProvider>;
        }
        case STORED_PAYMENT: {
            return <StoredPaymentTabs><CreditCardForm {...methodProps} /></StoredPaymentTabs>
        }
        default: {
            return <CreditCardForm {...methodProps} />;
        }
    }
};

PaymentMethod.propTypes = {
    totalValue: PropTypes.number.isRequired
};

export default PaymentMethod;
